import clsx from 'clsx';

const AddToCartIcon = ({
  height = '20px',
  width = '20px',
  className,
}: {
  height?: string;
  width?: string;
  className?: string;
}) => (
  <img
    src="/assets/images/add-to-cart.png"
    alt="Add to Cart Icon"
    height={height}
    width={width}
    className={clsx('object-contain', className)}
  />
);

export default AddToCartIcon;

